import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card} from 'antd';

import * as actions from '../redux/actions/index';
import AreaChart from "../charts/AreaChart";

class NationalAreaCard extends Component {
  render() {
    const onClick = year => {
      this.props.actions.selectYear(year);
    };

    return (
      <Card className="NationalAreaCard" noHovering={true} loading={this.props.loading}>
        <h2 className="subtitle">
          National Selected Dimensions Over Time<br/>
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
          {this.props.xLabel} &nbsp;
          <small>vs</small> &nbsp;
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
          {this.props.yLabel}
        </h2>
        <AreaChart
          dimX={this.props.xField}
          dimY={this.props.yField}
          titleX={this.props.xLabel}
          titleY={this.props.yLabel}
          year={this.props.year}
          data={this.props.data}
          onClick={onClick}
        />
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.states.loading || store.dimensions.loading,
    selectedState: store.states.selected,
    data: store.states.averages,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(NationalAreaCard);



// WEBPACK FOOTER //
// ./src/containers/NationalAreaCard.js